export const ResendEmailCodes = {
  update: 5,
  registration: 3,
} as const;

export const UpdateResendMode = 'update';
export const RegistrationResendMode = 'registration';
